var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.9 73.4C374.4 60.9 394.7 60.9 407.2 73.4L567.2 233.4C579.7 245.9 579.7 266.2 567.2 278.7C554.7 291.2 534.4 291.2 521.9 278.7L511.4 268.2L413.2 382.8C425.1 422.8 422 466.8 402.5 506L401.1 508.8C396.5 518 387.8 524.4 377.6 526.1C367.4 527.8 357.1 524.4 349.8 517.1L123.5 290.7C116.2 283.4 112.9 273.1 114.5 262.9C116.1 252.7 122.6 244 131.8 239.4L134.6 238C173.7 218.4 217.7 215.3 257.8 227.3L372.4 129.1L361.9 118.6C349.4 106.1 349.4 85.8 361.9 73.3zM73.9 521.4L180 415.2L225.3 460.5L119.1 566.6C106.6 579.1 86.3 579.1 73.8 566.6C61.3 554.1 61.3 533.8 73.8 521.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon-pin.b5ba13388909e8280d3e4d543fe57e9f.svg";
export { ForwardRef as ReactComponent };